<template>
    <component :is="col.content.component" v-bind="options" v-on="$listeners" />
</template>

<script>
export default {
    name: 'oc-component-row-cell',
    inject: ['$source'],
    props: ['row', 'col', 'index', 'options']
}
</script>
